import { render, staticRenderFns } from "./PasswordPage.vue?vue&type=template&id=241a7ded&scoped=true"
import script from "./PasswordPage.vue?vue&type=script&lang=js"
export * from "./PasswordPage.vue?vue&type=script&lang=js"
import style0 from "./PasswordPage.vue?vue&type=style&index=0&id=241a7ded&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a7ded",
  null
  
)

export default component.exports